<template>
  <div class="suspensionTag">
    <div style="padding: 8px 0px 10px 0px;background-color: rgb(215, 215, 215);text-align: center;">
      <span style="font-size: 18px;">选中数据2</span>
    </div>
    <el-table
      :show-header="false"
      style="width: 100%;"
      :height="listHeight"
      ref="singleTable"
      :data="resultList"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :prop="column.value"
        :label="column.text"
        :width="column.width"
      ></el-table-column>
    </el-table>
    <div style="padding-bottom: 10px;margin-top: 10px;text-align: center;">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-tickets"
        @click="detailedClick"
        v-show="isDetailed"
        round
      >详细</el-button>
      <!-- <el-button type="primary" size="mini" icon="el-icon-plus" @click="addClick" round>创建</el-button> -->
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-circle-check-outline"
        @click="saveClick"
        round
      >保存</el-button>
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-circle-close-outline"
        @click="deleteClick"
        round
      >删除</el-button>
    </div>
    <createTemplate ref="createTemplate" :body="false" :temType="1"></createTemplate>
  </div>
</template>

<script>
import createTemplate from "./createTemplate.vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import { UpdateTemplate } from "@/api/modules/basicData/task";
export default {
  components: {
    createTemplate
  },
  data() {
    return {
      nowRow: null,
      currentRow: null,
      listHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight - 1000 //（这里的240是减去表格上面导航和搜索条件的高度）
    };
  },
  created() {
    var a = $(window).height();
    this.listHeight = a - 230;
    // 			this.$root.$on('to_news',data => {
    // 				console.log(data,"------------")
    // 			})
    // 			Hub.$on('change', (val) => { //Hub接收事件
    // 				// this.msg = 'hehe';
    // 				console.log(val,"非父子组件通信")
    // 			});
  },
  props: {
    // userId: String,
    //列配置
    columns: {
      type: Array,
      default: function() {
        return [
          // 列
          {
            text: "任务名称",
            value: "TASKNAME"
          }
        ];
      }
    },
    isDetailed: {
      //是否显示详情
      type: Boolean,
      default: true
    },
    filedID: {
      type: String,
      default: "ID"
    }
  },
  computed: {
    ...mapState({
      resultList: state => state.resultBase.resultList,
      resultSelection: state => state.resultBase.resultSelection,
      isResult: state => state.resultBase.isResult,
      tagItem: state => state.task.tagItem,
      resultTagItem: state => state.task.resultTagItem,
      category: state => state.task.category
    })
  },
  watch: {
    listHeight(val) {
      if (!this.timer) {
        this.listHeight = val;
        this.timer = true;
        const that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  },
  methods: {
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(row) {
      //当前行事件
      // console.log('当前：', row);
      this.nowRow = row;
      this.$store.commit("setResultSelection", row);
    },
    detailedClick() {
      //查看详情
      // 				this.$store.commit('changeTaskSource', this.resultList);
      // 				this.$store.commit('changeTotalCount', this.resultList.length);
      if (this.nowRow) {
        this.$emit("detailsEvent", this.resultSelection, function(str) {});
      }
    },
    deleteClick() {
      //删除当前行
      if (!this.resultSelection) {
        this.$message({
          type: "info",
          message: "请选择需要删除行"
        });
        return;
      }
      this.$store.commit("deleteResult", this.resultSelection.TeamId);
      if (this.resultList.length == 0) {
        this.$store.state.resultBase.isResult = false;
      }
    },
    addClick() {
      //创建结果集模板
      let idArr = [];
      this.resultList.forEach(c => {
        idArr.push(c[this.filedID]);
      });
      this.$refs.createTemplate.open();
      this.$refs.createTemplate.content = idArr.join(",");
    },
    saveClick() {
      console.log(this.resultList);
      console.log(this.tagItem, "tagItem");
      // return false
      let idArr = [];
      this.resultList.forEach(c => {
        idArr.push(c[this.filedID]);
      });
      if (this.isResult) {
        this.$confirm("请选择", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "创建新模板", //确定
          cancelButtonText: "保存到原模板", //删除
          type: "warning"
        })
          .then(() => {
            this.$refs.createTemplate.open();
            // this.$refs.createTemplate.userId = this.userId;
            this.$refs.createTemplate.content = idArr.join(",");
          })
          .catch(action => {
            if (action === "cancel") {
              let obj = this.resultTagItem;
              obj.CONTENT = idArr.join(",");
              console.log(obj, "obj");
              // return false
              UpdateTemplate(obj, this.category).then(res => {
                console.log(res);
                if (res == 1) {
                  this.$message({
                    type: "success",
                    message: "保存成功"
                  });
                }
              });
            }
          });
      } else {
        this.$refs.createTemplate.open();
        this.$refs.createTemplate.content = idArr.join(",");
      }
      // 				let idArr = [];
      // 				this.resultList.forEach((c) => {
      // 					idArr.push(c.ID)
      // 				})
      // 				this.$refs.createTemplate.open();
      // 				this.$refs.createTemplate.content = idArr.join(',')
    }
  }
};
</script>

<style lang="less">
.suspensionTag {
  background: white;
  .el-button + .el-button {
    margin-left: 0px;
  }
  .el-button--mini,
  .el-button--mini.is-round {
    padding: 7px 10px;
  }
}
</style>
<style scoped>
</style>
